import { type SchoolInfo } from '../../../hooks/useSchoolInfo';

interface ShowFeatureProps {
    school?: SchoolInfo;
    loadingSchool: boolean;
    isSuperAdmin: boolean;
}

export const showNonManagedZoomSetting = ({ school, loadingSchool, isSuperAdmin }: ShowFeatureProps): boolean => {
    if (loadingSchool) {
        // Hidden until school is loaded; prevents flashing advanced features unexpectedly
        return false;
    }

    if (isSuperAdmin) {
        // Class admins should be able to see all advanced features
        return true;
    }

    if (school?.isManagedZoom) {
        // Hide advanced features from managed zoom schools
        return false;
    }

    return true;
};

export const showNonCollabSetting = ({ school, loadingSchool, isSuperAdmin }: ShowFeatureProps): boolean => {
    if (loadingSchool) {
        // Hidden until school is loaded; prevents flashing advanced features unexpectedly
        return false;
    }

    if (isSuperAdmin) {
        // Class admins should be able to see all advanced features
        return true;
    }

    if (school?.isCollab) {
        // Hide advanced features from collab schools
        return false;
    }

    return true;
};
